/// <amd-module name="Feed/Legacy/Components/GlobalMessageBar" />
import * as React from "react";
import { connect } from "react-redux";

import { Link } from "VSSUI/Link";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";

import { IError } from "Feed/Common/Types/IError";
import { getErrorMessage, IFeedHubViewState } from "Feed/Core/Redux/FeedHub";
import { FeedHubActions } from "Feed/Core/Redux/FeedHub/FeedHubActions";

interface IGlobalMessageBarProps {
    error: IError;
}

const Actions = {
    clearErrorMessage: FeedHubActions.clearErrorMessage
};

function GlobalMessageBar(props: IGlobalMessageBarProps & typeof Actions) {
    const err = props.error;
    return (
        err != null &&
        err.message != null && (
            <MessageBar
                severity={err.isCritical ? MessageBarSeverity.Error : MessageBarSeverity.Warning}
                onDismiss={() => props.clearErrorMessage()}
            >
                <span>{err.message}</span>
                {err.link && err.linkText && (
                    <Link className="error-button" onClick={() => err!.link!()}>
                        {err.linkText}
                    </Link>
                )}
            </MessageBar>
        )
    );
}

function mapStateToProps(state: IFeedHubViewState): IGlobalMessageBarProps {
    return {
        error: getErrorMessage(state)
    };
}

export const ConnectedGlobalMessageBar = connect(mapStateToProps, Actions)(GlobalMessageBar);
